(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-order-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const API_URL = 'https://downloads.antesports.com/shopify/bulkorder-email';
  var SECTION_ID = '';

  /* ---- Helpers ---- */
  function isValidEmail(val) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim()); }
  function isValidPhone(val) { return /^[0-9]{10}$/.test(val.trim()); }

  function setFieldError(fieldName, message) {
    var input = document.getElementById('bulk-' + fieldName + '-' + SECTION_ID);
    var errEl = document.getElementById('error-' + fieldName + '-' + SECTION_ID);
    if (input) {
      if (message) {
        input.classList.add('bulk-input--error');
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.classList.remove('bulk-input--error');
        input.removeAttribute('aria-invalid');
      }
    }
    if (errEl) errEl.textContent = message || '';
  }

  function clearAllErrors(form) {
    form.querySelectorAll('.bulk-form-input, .bulk-form-textarea').forEach(function (inp) {
      inp.classList.remove('bulk-input--error');
      inp.removeAttribute('aria-invalid');
    });
    form.querySelectorAll('.bulk-field-error').forEach(function (el) { el.textContent = ''; });
  }

  function showMessage(type, text) {
    var msgEl = document.getElementById('bulk-form-message-' + SECTION_ID);
    if (!msgEl) return;
    msgEl.className = 'bulk-form-message';
    msgEl.classList.add(type === 'success' ? 'bulk-form-message--success' : 'bulk-form-message--error');
    msgEl.textContent = text;
    msgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideMessage() {
    var msgEl = document.getElementById('bulk-form-message-' + SECTION_ID);
    if (!msgEl) return;
    msgEl.className = 'bulk-form-message';
    msgEl.textContent = '';
  }

  function setButtonState(btn, state) {
    var textEl = btn.querySelector('.bulk-btn-text');
    if (state === 'default') {
      btn.disabled = false;
      btn.classList.remove('bulk-submit-btn--submitting');
      if (textEl) textEl.textContent = 'Submit';
    } else if (state === 'submitting') {
      btn.disabled = true;
      btn.classList.add('bulk-submit-btn--submitting');
      if (textEl) textEl.textContent = 'Submitting...';
    } else if (state === 'success') {
      btn.disabled = true;
      btn.classList.remove('bulk-submit-btn--submitting');
      if (textEl) textEl.textContent = 'Submitted successfully';
    }
  }

  /* ---- Validation ---- */
  function validateForm(fields) {
    var valid = true;

    function req(key, msg) {
      if (!fields[key].trim()) { setFieldError(key, msg); valid = false; return false; }
      setFieldError(key, '');
      return true;
    }

    req('name', 'Proprietor/Partner Name is required.');
    req('business', 'Registered Business Name is required.');
    req('gst', 'GST No is required.');

    if (req('email', 'E-Mail is required.') && !isValidEmail(fields.email)) {
      setFieldError('email', 'Please enter a valid email address.');
      valid = false;
    }
    if (req('phone', 'Phone Number is required.') && !isValidPhone(fields.phone)) {
      setFieldError('phone', 'Please enter a valid phone number.');
      valid = false;
    }
    if (req('altphone', 'Alternate Phone Number is required.') && !isValidPhone(fields.altphone)) {
      setFieldError('altphone', 'Please enter a valid alternate phone number.');
      valid = false;
    }

    req('state', 'State is required.');
    req('city', 'City is required.');
    req('message', 'Please enter your query.');

    return valid;
  }

  /* ---- Live validation ---- */
  function attachLiveValidation(form) {
    form.querySelectorAll('.bulk-form-input, .bulk-form-textarea').forEach(function (inp) {
      inp.addEventListener('blur', function () {
        if (inp.hasAttribute('aria-invalid') || inp.value.trim() !== '') {
          var fieldName = inp.name;
          var val = inp.value;

          if (fieldName === 'email') {
            if (!val.trim()) setFieldError('email', 'E-Mail is required.');
            else if (!isValidEmail(val)) setFieldError('email', 'Please enter a valid email address.');
            else setFieldError('email', '');
          } else if (fieldName === 'phone' || fieldName === 'altphone') {
            if (!val.trim()) {
              setFieldError(fieldName, fieldName === 'phone' ? 'Phone Number is required.' : 'Alternate Phone Number is required.');
            } else if (!isValidPhone(val)) {
              setFieldError(fieldName, 'Please enter a valid phone number.');
            } else {
              setFieldError(fieldName, '');
            }
          } else if (val.trim()) {
            setFieldError(fieldName, '');
          }
        }
      });

      inp.addEventListener('input', function () {
        if (inp.classList.contains('bulk-input--error') && inp.value.trim() !== '') {
          setFieldError(inp.name, '');
        }
      });
    });
  }

  /* ---- Submit ---- */
  function handleSubmit(form, btn, isSubmitting) {
    return function (e) {
      e.preventDefault();
      if (isSubmitting[0]) return;
      hideMessage();

      function val(id) { return (document.getElementById(id + '-' + SECTION_ID) || {}).value || ''; }

      var fields = {
        name: val('bulk-name'),
        business: val('bulk-business'),
        gst: val('bulk-gst'),
        email: val('bulk-email'),
        phone: val('bulk-phone'),
        altphone: val('bulk-altphone'),
        state: val('bulk-state'),
        city: val('bulk-city'),
        message: val('bulk-message')
      };

      clearAllErrors(form);

      if (!validateForm(fields)) {
        var firstError = form.querySelector('.bulk-input--error');
        if (firstError) firstError.focus();
        return;
      }

      isSubmitting[0] = true;
      setButtonState(btn, 'submitting');

      /* PHP controller reads via getPost(): form-encoded, NOT JSON */
      var formData = new FormData();
      Object.keys(fields).forEach(function (k) { formData.append(k, fields[k].trim()); });

      fetch(API_URL, { method: 'POST', body: formData })
        .then(function (response) {
          return response.text().then(function (text) {
            return { status: response.status, ok: response.ok, text: text };
          });
        })
        .then(function (res) {
          var data = null;
          try { data = JSON.parse(res.text); } catch (err) { data = null; }

          if (data && data.success === true) {
            setButtonState(btn, 'success');
            showMessage('success', data.message || 'Thank you. Our team will contact you shortly.');
            form.reset();
            setTimeout(function () {
              isSubmitting[0] = false;
              setButtonState(btn, 'default');
            }, 3000);
          } else {
            isSubmitting[0] = false;
            setButtonState(btn, 'default');
            showMessage('error', (data && data.message) || 'Unable to submit your enquiry. Please try again.');
          }
        })
        .catch(function (error) {
          console.error('Bulk Order Error:', error);
          isSubmitting[0] = false;
          setButtonState(btn, 'default');
          showMessage('error', 'Something went wrong. Please try again later.');
        });
    };
  }

  /* ---- Init ---- */
  function init() {
    var formEl = document.querySelector('[id^="bulk-order-form-"]');
    if (!formEl) return;
    SECTION_ID = formEl.id.replace('bulk-order-form-', '');
    var btn = document.getElementById('bulk-submit-btn-' + SECTION_ID);
    if (!btn) return;
    var isSubmitting = [false];
    attachLiveValidation(formEl);
    formEl.addEventListener('submit', handleSubmit(formEl, btn, isSubmitting));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Touch: show pill on first tap, navigate on second tap
  function initTouchCards(root) {
    if (!('ontouchstart' in window)) return;
    var cards = (root || document).querySelectorAll('.cg-card');

    cards.forEach(function (card) {
      var tapped = false;
      var timer  = null;

      card.addEventListener('touchstart', function (e) {
        if (!tapped) {
          e.preventDefault();
          tapped = true;
          card.classList.add('cg-card--touched');

          clearTimeout(timer);
          timer = setTimeout(function () {
            tapped = false;
            card.classList.remove('cg-card--touched');
          }, 2000);
        } else {
          clearTimeout(timer);
        }
      }, { passive: false });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTouchCards();
  });


  // Theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.cg-grid')) {
      initTouchCards(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-marquee')) {
    class ShoppableMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.group = this.querySelector('[data-group]');
        if (!this.track || !this.group) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._onClick = this.onClick.bind(this);
        this._onDocClick = (e) => { if (!this.contains(e.target)) this.closePopovers(); };
        this._onKey = (e) => { if (e.key === 'Escape') this.closePopovers(true); };

        this.addEventListener('click', this._onClick);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);

        // Give YouTube embeds their src (with origin) BEFORE cloning
        this.group.querySelectorAll('iframe[data-src]').forEach((f) => {
          if (!f.getAttribute('src')) {
            f.src = f.dataset.src + '&origin=' + encodeURIComponent(window.location.origin);
          }
        });

        let t;
        this._ro = new ResizeObserver(() => {
          clearTimeout(t);
          t = setTimeout(() => this.build(), 150);
        });
        this._ro.observe(this);
        this._ro.observe(this.group);

        // play native videos only while the strip is on screen
        this._io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.syncVideos();
        }, { threshold: 0.05 });
        this._io.observe(this);

        this.build();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        this._ro && this._ro.disconnect();
        this._io && this._io.disconnect();
      }

      /* ---------- Marquee ---------- */
      build() {
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        const groupW = this.group.getBoundingClientRect().width;
        if (!groupW || this.reduced) return;

        const viewport = this.clientWidth || window.innerWidth;
        const copies = Math.max(1, Math.ceil(viewport / groupW));

        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          // clones always start muted
          clone.querySelectorAll('[data-sound]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          clone.querySelectorAll('video').forEach((v) => { v.muted = true; });
          this.track.appendChild(clone);
        }

        const speed = parseFloat(this.dataset.speed) || 40; // px per second
        this.style.setProperty('--ssm-distance', groupW + 'px');
        this.style.setProperty('--ssm-duration', (groupW / speed).toFixed(2) + 's');
        this.classList.add('is-ready');
        this.syncVideos();
      }

      syncVideos() {
        this.querySelectorAll('video').forEach((v) => {
          if (this.visible === false) v.pause();
          else { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        });
      }

      /* ---------- Sound ---------- */
      postYT(iframe, func, args) {
        try {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: func, args: args || [] }),
            '*'
          );
        } catch (e) {}
      }

      setSound(card, on) {
        const btn = card.querySelector('[data-sound]');
        if (btn) {
          btn.setAttribute('aria-pressed', String(on));
          btn.setAttribute('aria-label', on ? this.dataset.labelSoundOff : this.dataset.labelSoundOn);
        }
        card.querySelectorAll('video').forEach((v) => {
          v.muted = !on;
          if (on) v.volume = 1;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        });
        card.querySelectorAll('iframe[data-embed="youtube"]').forEach((f) => {
          if (on) {
            this.postYT(f, 'unMute');
            this.postYT(f, 'setVolume', [100]);
          } else {
            this.postYT(f, 'mute');
          }
          this.postYT(f, 'playVideo');
        });
      }

      muteOthers(except) {
        this.querySelectorAll('.ssm__card').forEach((c) => {
          if (c === except) return;
          const b = c.querySelector('[data-sound][aria-pressed="true"]');
          if (b) this.setSound(c, false);
        });
      }

      toggleSound(btn) {
        const card = btn.closest('.ssm__card');
        const turnOn = btn.getAttribute('aria-pressed') !== 'true';
        if (turnOn) this.muteOthers(card);
        this.setSound(card, turnOn);
      }

      /* ---------- Interactions (delegated so clones work too) ---------- */
      onClick(e) {
        const snd = e.target.closest('[data-sound]');
        if (snd) return this.toggleSound(snd);

        const opt = e.target.closest('[data-variant]');
        if (opt) return this.selectVariant(opt);

        const toggle = e.target.closest('[data-toggle]');
        if (toggle) return this.togglePopover(toggle.closest('.ssm__card'));

        const atc = e.target.closest('[data-atc]');
        if (atc) return this.add(atc);
      }

      togglePopover(card) {
        const pop = card.querySelector('[data-popover]');
        const btn = card.querySelector('[data-toggle]');
        const open = pop.hidden;
        this.closePopovers();
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        this.classList.toggle('is-paused', open);
        if (open) {
          const sel = pop.querySelector('[aria-selected="true"]:not(:disabled)') || pop.querySelector('button:not(:disabled)');
          sel && sel.focus({ preventScroll: true });
        }
      }

      closePopovers(returnFocus) {
        this.querySelectorAll('[data-popover]:not([hidden])').forEach((p) => {
          p.hidden = true;
          const btn = p.closest('.ssm__card').querySelector('[data-toggle]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (returnFocus) btn.focus(); }
        });
        this.classList.remove('is-paused');
      }

      selectVariant(opt) {
        const card = opt.closest('.ssm__card');
        card.dataset.variantId = opt.dataset.id;
        card.querySelectorAll('[data-variant]').forEach((o) =>
          o.setAttribute('aria-selected', String(o === opt))
        );
        const label = card.querySelector('[data-variant-label]');
        if (label) label.textContent = opt.dataset.title;
        const price = card.querySelector('[data-price]');
        if (price) price.textContent = opt.dataset.price;
        this.closePopovers();
      }

      setLabel(btn, text) {
        const el = btn.querySelector('[data-atc-label]');
        if (el) el.textContent = text;
      }

      async add(btn) {
        if (btn.dataset.loading === 'true') return;
        const card = btn.closest('.ssm__card');
        const id = Number(card.dataset.variantId);
        if (!id) return;

        btn.dataset.loading = 'true';
        this.setLabel(btn, this.dataset.labelAdding);

        let ok = false;
        let message = '';
        try {
          const data = await this.request(id);
          await this.refreshCart(data);
          ok = true;
        } catch (err) {
          message = err && err.message ? err.message : 'Error';
        }

        this.setLabel(btn, ok ? this.dataset.labelAdded : message);
        setTimeout(() => {
          btn.dataset.loading = 'false';
          this.setLabel(btn, this.dataset.labelAdd);
        }, ok ? 1400 : 2600);
      }

      /* ---------- Cart ---------- */
      get dawnDrawer() {
        const d = document.querySelector('cart-drawer');
        return d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function' ? d : null;
      }

      async request(variantId) {
        const payload = { items: [{ id: variantId, quantity: 1 }] };
        const drawer = this.dawnDrawer;
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
          payload.sections_url = window.location.pathname;
        }
        const res = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add');
        }
        return data;
      }

      async refreshCart(data) {
        const drawer = this.dawnDrawer;
        if (drawer && data.sections) {
          drawer.renderContents(data);
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shoppable-marquee', cartData: data });
            }
          } catch (e) {}
          return;
        }

        const sectionId = (this.dataset.cartSection || '').trim();
        if (sectionId) {
          try {
            const r = await fetch(`${this.dataset.rootUrl}?sections=${encodeURIComponent(sectionId)}`);
            const json = await r.json();
            const html = json[sectionId];
            const target = document.getElementById('shopify-section-' + sectionId);
            if (html && target) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.getElementById('shopify-section-' + sectionId);
              target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
            }
          } catch (e) {}
        }

        let cart = null;
        try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {}

        ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build', 'cart:item-added', 'product:added', 'ajaxProduct:added', 'cart.requestComplete']
          .forEach((name) => {
            const ev = new CustomEvent(name, { bubbles: true, detail: { cart, item: data, source: 'shoppable-marquee' } });
            document.dispatchEvent(ev);
            window.dispatchEvent(new CustomEvent(name, { detail: { cart, item: data, source: 'shoppable-marquee' } }));
          });

        await new Promise((r) => setTimeout(r, 200));

        const selector = (this.dataset.openSelector || '').trim();
        const opener = selector ? document.querySelector(selector) : null;
        if (opener) {
          opener.click();
        } else if (this.dataset.redirect === 'true') {
          window.location.href = this.dataset.cartUrl;
        }
      }
    }
    customElements.define('shoppable-marquee', ShoppableMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
